import { REDUX_ACTIONS } from 'utils/constants';
import { ModalTypes } from 'components/organisms/ModalHandler';

export function openModal(modalType: ModalTypes, props: any = {}) {
  return (dispatch) => {
    document.body.style.overflow = 'hidden';
    return dispatch({ type: REDUX_ACTIONS.MODAL_OPEN, modalType, props });
  };
}

export function closeModal() {
  const body = document.body;
  body.style.overflow = 'auto';
  body.style.position = 'unset';
  body.style.top = '';
  document.body.classList.toggle('modal-active', false);
  return { type: REDUX_ACTIONS.MODAL_CLOSE };
}
